import React from 'react';
import './App.css';
import NavBar from './components/NavBar';
import HeaderFunction from './components/HeaderFunction';
import Profile from './components/Profile';
import Education from './components/Education';
import WorkExperience from './components/WorkExperience';
import Projects from './components/ProjectCarousel';
import Technologies from './components/Technologies';
import EmailForm from './components/EmailForm';
import GitHub from './images/github.svg';
import LinkedIn from './images/linkedin.svg';
import TopDownSurvivor from './images/TopDownSurvivor.png';
import KnightsAndVikings from './images/KnightsAndVikings.png';
import TerrainGenerator from './images/TerrainGenerator.png';
import IndoorSimulation from './images/IndoorSimulation.png';
import FModDemo from './images/FModDemo.png';
import SpellSurge from './images/SpellSurge_Icon.png';

const projects = [
	{
		title: 'TopDown Survivor',
		image: TopDownSurvivor,
		link: 'https://www.youtube.com/watch?v=P8b-jFs3tXg',
		description:
			'A solo Unity project — a top-down shooter focused on survival mechanics, built entirely from scratch.',
		tags: ['Unity', 'C#', 'Game Design', 'AI'],
		learnMoreDescription:
			'TopDown Survivor is a personal project I developed to explore core game mechanics and systems design. Built from the ground up in Unity, it features dynamic enemy AI, a variety of weapons and items, and a unique building mechanic. The game emphasizes replayability and strategic decision-making, with players navigating through increasingly challenging environments while managing resources and combat encounters.',
	},
	{
		title: 'Knights & Vikings',
		image: KnightsAndVikings,
		link: 'https://www.youtube.com/watch?v=CjDT-aUH3y4',
		description:
			'A 2D online PvP platformer built in Unity with real-time multiplayer connectivity. Players compete for points across arenas.',
		tags: ['Unity', 'C#', 'Photon', 'Multiplayer'],
		learnMoreDescription:
			'Knights & Vikings is a 2D online PvP platformer that I developed to delve into real-time multiplayer game development using Unity. The game features fast-paced combat where players choose between two factions, Knights or Vikings, and battle across various arenas to earn points. This was made using Photon and was a great learning experience in implementing smooth multiplayer mechanics, including player synchronization, and latency compensation.',
	},
	{
		title: 'Thesis Simulation',
		image: IndoorSimulation,
		link: 'https://www.youtube.com/watch?v=K-2IAdgajRQ',
		description:
			'An indoor crowd simulation in Unity using A* Pathfinding and ML-Agents, modelling how a crowd reacts to an emergency.',
		tags: ['Unity', 'C#', 'ML-Agents', 'A* Pathfinding'],
		learnMoreDescription:
			'This simulation was the core of my BSc thesis, where I explored crowd behaviour in emergency situations. Using Unity, I implemented A* pathfinding for navigation and integrated ML-Agents to create adaptive, intelligent agents that react to their environment and each other. The simulation models how crowds respond to emergencies, providing insights into evacuation dynamics and potential safety improvements whilst also providing programmers with insightful data as to which AI felt more realistic to players.',
	},
	{
		title: 'FMod Demo',
		image: FModDemo,
		link: 'https://www.youtube.com/watch?v=5hQ8ImFaOj4',
		description:
			'A demo integrating FMOD with TopDown Survivor to add adaptive, randomized sound design to a Unity game.',
		tags: ['Unity', 'C#', 'FMOD', 'Audio Design'],
		learnMoreDescription:
			"This project was a personal experiment to integrate FMOD, a powerful audio middleware, with my TopDown Survivor game. The goal was to enhance the game's sound design by creating adaptive and randomized audio elements that respond to in-game events and player actions. By using FMOD's features, I was able to implement dynamic music transitions, contextual sound effects, and procedural audio generation, significantly improving the overall immersion and auditory experience of the game.",
	},
	{
		title: 'Terrain Generator',
		image: TerrainGenerator,
		link: 'https://www.youtube.com/watch?v=bpwgRaaBucw',
		description:
			'Procedurally generated maps in Unity — mazes, terrain and racing tracks generated using only code-based algorithms.',
		tags: ['Unity', 'C#', 'Procedural Generation', 'Algorithms'],
		learnMoreDescription:
			'This project was a deep dive into procedural generation techniques in Unity. I developed algorithms to create various types of maps, including mazes, terrains, and racing tracks, all generated purely through code. The generator allows for endless variations, providing unique experiences each time. This project helped me understand complex algorithmic design and how to create engaging content programmatically.',
	},
	{
		title: 'Spell Surge',
		image: SpellSurge,
		size: 'contain',
		description:
			'A personal Roblox Studio project featuring a custom spell casting system and a variety of abilities to discover and use.',
		badge: true,
		tags: ['Roblox Studio', 'Lua', 'Game Design'],
		learnMoreDescription:
			'Spell Surge is a personal project I am developing in Roblox Studio to create a unique spell-casting system. The game features a variety of abilities that players can discover and use in combat. I designed and implemented the mechanics for casting spells, including cooldowns, mana management, and visual effects. This project allowed me to explore game development within the Roblox platform and experiment with creative gameplay mechanics.',
	},
];

function Footer() {
	return (
		<footer className="site-footer">
			<p className="footer-copy">
				Built with React &amp; Tailwind ·{' '}
				<a href="https://icons8.com/" target="_blank" rel="noopener noreferrer">
					Icons by icons8.com
				</a>
			</p>
			<div className="footer-links">
				<a
					href="https://github.com/Nate-Lia"
					target="_blank"
					rel="noopener noreferrer"
					className="footer-icon-link"
				>
					<img src={GitHub} alt="GitHub" />
				</a>
				<a
					href="https://www.linkedin.com/in/nathan-lia-b321a822b/"
					target="_blank"
					rel="noopener noreferrer"
					className="footer-icon-link"
				>
					<img src={LinkedIn} alt="LinkedIn" />
				</a>
			</div>
		</footer>
	);
}

export default function App() {
	return (
		<div className="page-wrap">
			<NavBar />
			<Profile />

			<div className="page-section">
				<div className="edu-work-grid">
					<div>
						<HeaderFunction title="Education" id="education" />
						<Education />
					</div>
					<div>
						<HeaderFunction title="Work Experience" id="work-experience" />
						<WorkExperience />
					</div>
				</div>
			</div>

			<div className="page-section">
				<HeaderFunction title="Projects" id="projects" />
				<Projects projects={projects} />
			</div>

			<div className="page-section">
				<HeaderFunction title="Familiar Technologies" id="tech" />
				<Technologies />
			</div>

			<div
				className="page-section"
				style={{ maxWidth: '536px', margin: '0 auto' }}
			>
				<HeaderFunction title="Contact Me" id="contact" />
				<EmailForm />
			</div>

			<div style={{ height: '48px' }} />
			<Footer />
		</div>
	);
}
